module.exports = __webpack_public_path__ + "media/Nao, nao estou.2bf940cc.mp3";